<template>
  <div class="VTable__wrap">
    <div class="shadow main" ref='main'>
      <el-table
        ref="tableDom"
        v-loading="loading"
        highlight-current-row
        :default-expand-all="defaultExpandAll"
        row-key="id"
        :element-loading-text="loadingText"
        :data="data"
        :height="height"
        :header-cell-style="{background:'#FAFAFA'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="showSelect"
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="60">
        </el-table-column>
        <el-table-column
          v-for="item in field"
          :key="item.name"
          :prop="item.name"
          :label="item.label"
          :show-overflow-tooltip="item.showTooltip?true:false"
          :min-width="item.width?item.width:''"
          :width="item.width?item.width:''"
          :fixed="item.fixed"
        >
          <template slot-scope="{ row, $index }">
            <slot :name="item.name" :row="row" :$index="$index">{{ row[item.name] }}</slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination__wrap' v-if='hasPagionation'>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'VTable',
    props: {
      title: { required: false, type: String, default: "" },
      addText: { required: false, type: String, default: "新增" },
      lazy: { required: false, type: Boolean, default: false },
      hasPagionation: { required: false, type: Boolean, default: false },
      showOverflowTooltip: { required: false, type: Boolean, default: true },
      exportText: { required: false, type: String, default: "导出" },
      loading: { type: Boolean, default: false },
      loadingText: { type: String, default: "加载中" },
      auth: { required: false, type: Array, default: () => [] },
      field: { required: false, type: Array, default: () => [] },
      data: { type: Array, default: () => [] },
      page: { required: false, type: Number, default: 1 },
      pageSize: { required: false, type: Number, default: 10 },
      total: { required: false, type: Number, default: 0 },
      defaultExpandAll: { require: false, type:Boolean, default: false},
      showSelect: { required: false, type: Boolean, default: false },
    },
    data() {
      return {
        height: 0,
      }
    },
    watch: {
      field(val) {
        this.calcHeight();
      },
      data: {
        handler(val) {
          // 数据更新时重算高度：刷新页面时 mounted 时刻布局可能未稳定（字体加载/表单换行），
          // 数据返回后重算可自动纠正，避免高度偏大把分页器挤出可视区
          this.calcHeight();
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      handleSizeChange(pageSize) {
        this.$emit("handleSizeChange", pageSize);
      },
      handleCurrentChange(page) {
        this.$emit("handleCurrentChange", page)
      },
      // 批量选择
      handleSelectionChange(batchData) {
        this.$emit('handleSelectionChange', batchData)
      },
      /**
       * 计算表格可用高度
       * 原理：用 getBoundingClientRect().top 取表格相对视口的距离，
       *       window.innerHeight 减去该距离和底部预留 60px（分页器 + 间距）
       * 数据变化 / 列变化 / 窗口 resize 时自动重算
       */
      calcHeight() {
        this.$nextTick(() => {
          const table = this.$refs.tableDom;
          if (!table || !table.$el) return;
          const el = table.$el;
          // 组件不可见（父级 v-if/v-show 未显示）时跳过，
          // 否则 offsetParent 为 null 会算出超大高度，把分页器挤出屏幕
          if (!el.offsetParent) return;
          const top = Math.max(0, el.getBoundingClientRect().top);
          const height = window.innerHeight - top - 60;
          // 最小高度保护，避免异常布局下表格被压没
          this.height = height < 200 ? 200 : height;
          if (table.doLayout) {
            table.doLayout();
          }
        });
      },
    },
    mounted() {
      this.calcHeight();
      window.addEventListener("resize", this.calcHeight);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.calcHeight);
    },
  }
</script>
<style scoped lang="scss">
  .VTable__wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .main {
      flex: 1;
      margin-bottom: 10px;
    }
    .pagination__wrap {
      text-align: right;
      padding: 0 50px;
    }
  }

.VTable__wrap ::v-deep .el-table__header,
.VTable__wrap ::v-deep .el-table__body,
.VTable__wrap ::v-deep .el-table__footer {
  table-layout: fixed !important;
  .cell.el-tooltip {
    width: auto !important;
  }
}

.VTable__wrap ::v-deep .el-table {
  .el-table__fixed-right {
    right: 0 !important;
    z-index: 2;
    .el-table__fixed-right-patch {
      background-color: #f5f7fa;
    }
    th, td {
      background-color: #fff;
    }
  }
  
  .el-table__fixed-right-wrapper {
    box-shadow: -8px 0 10px -5px rgba(0, 0, 0, 0.12);
    th, td {
      background-color: #fff;
    }
  }
  
  .el-table__fixed {
    z-index: 2;
    box-shadow: 8px 0 10px -5px rgba(0, 0, 0, 0.12);
    th, td {
      background-color: #fff;
    }
  }
}
</style>